import {
    AssignmentInd,
    AssignmentInd as AssignmentIndIcon,
    DoNotDisturb as DoNotDisturbIcon,
    FileDownloadDone as FileDownloadDoneIcon,
    History as HistoryIcon,
    Search as SearchIcon,
    Security,
    Videocam,
} from "@mui/icons-material";
import ArticleIcon from '@mui/icons-material/Article';
import PieChartIcon from "@mui/icons-material/PieChart";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import svgAccesibilidad from "/ACCESIBILIDAD-N.svg";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import { Card, CardContent } from "@mui/material";
import { ContainerScreenGeneral } from "../../components";
import { useWindowSize } from "../../hooks";
import { useContext } from "react";
import { UserContext } from "../../context";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const MenuFM = () => {

    const { actions } = useContext(UserContext);
    const size = useWindowSize();
    const { width } = size;

    const nav = useNavigate();

    const menuOptions = [
        {
            title: "Actas",
            description: "Visualiza toda las infracciones realizadas.",
            path: "/gestion-actas",
            roles: ['admin', 'admin.app', 'tribunales'],
            permisos: [],
            icon: <ArticleIcon sx={{ fontSize: 65, color: "#133040" }} />,
        },
        {
            title: "Actas Anuladas",
            description: "Gestiona el cheque de toda las actas anuladas.",
            path: "/actas-anuladas",
            condicion: "and",
            roles: ['admin', 'admin.app'],
            permisos: ['JP'],
            icon: <RemoveCircleOutlineIcon sx={{ fontSize: 65, color: "#dc3545" }} />,
        },
        {
            title: "Buscar Acta",
            description: "Busca acta por patente, numero acta o DNI .",
            path: "/buscar-acta",
            roles: ['admin', 'admin.app', '147', 'tribunales'],
            icon: <SearchIcon sx={{ fontSize: 65, color: "#133040" }} />,
        },
        {
            title: "Notificar",
            description: "Menu de acciones del notificador",
            // path: "/notificador/listado-actas",
            path: "/notificador",
            permisos: [],
            roles: ['notificador'],
            icon: <LocalShippingIcon sx={{ fontSize: 65, color: "#133040" }} />,
        },
        {
            title: "Notificador",
            description: "Información sobre los notificadores",
            path: "/notificador/reportes",
            roles: ['admin'],
            permisos: ['JP', 'reporte.notificador.view'],
            icon: <AssignmentInd sx={{ fontSize: 65, color: "#133040" }} />,
        },
        {
            title: "Credenciales",
            description: "Credenciales de los notificadores.",
            path: "/notificador/credenciales",
            roles: ['admin'],
            permisos: ['JP'],
            icon: <RecentActorsIcon sx={{ fontSize: 65, color: "#133040" }} />,
        },
        {
            title: "Camaras",
            description: "Mapa de las camaras en la ciudad.",
            path: "/mapa-de-puntos",
            roles: ['admin'],
            permisos: [],
            icon: <Videocam sx={{ fontSize: 65, color: "#133040" }} />,
        },
        {
            title: "Estadisticas",
            description: "Informaciones sobre las actas en general.",
            path: "/estadisticas",
            roles: ['admin'],
            permisos: ['JP'],
            icon: <PieChartIcon sx={{ fontSize: 65, color: "#133040" }} />,
        },
        {
            title: "Admin",
            description: "Panel de accion del administrador.",
            path: "/menu-admin",
            roles: ['admin'],
            permisos: ['JP'],
            icon: <Security sx={{ fontSize: 65, color: "#133040" }} />,
        },
        {
            title: "MCD",
            description: "Gestion de infracciones NqnAccesible.",
            path: "/mcd",
            roles: ['admin'],
            permisos: ['JP'],
            icon: <img src={svgAccesibilidad} style={{ width: "65px", height: "65px" }} />,
        },
    ];
    // console.log(menuOptions);

    return (
        <section>
            <ContainerScreenGeneral size={'lg'}>
                {/* <section className="flex flex-col items-center mt-10 "> */}
                <section className="d-flex flex-column align-items-center " style={{ marginTop: "2rem" }}>
                    {/* <h2 className="mb-4 pt-6 font-bold text-[1.5rem]">Trámites de Patente</h2> */}
                    <h1 className="fs-4">Monitoreo Vial Digital</h1>
                    <p className="text-center fw-light fs-6 py-3">
                        Bienvenido al sistema de gestión de Foto Multas.
                    </p>
                </section>
                <div
                    className={` d-flex flex-wrap mx-auto justify-content-center w-100  ${width >= 640 ? "" : "flex-column"} `}
                    style={{ maxWidth: "1050px" }}
                >
                    {menuOptions.map((opc) => {
                        if (opc?.condicion == "and") {
                            if ((opc.roles &&
                                opc.roles.some((role) =>
                                    actions.user().roles?.some((userRole) => userRole.name == role)
                                )
                            ) && (
                                    opc.permisos && opc.permisos.some((permiso) => actions.user().permissions?.some((userPermiso) => userPermiso.name == permiso))
                                )) {
                                return (
                                    <section key={opc.title} className={`m-0  ${width < 640 ? "row p-3 " : width < 992 ? "row p-0" : "row p-3"} `} >
                                        <Card key={opc.title} className={` rounded d-flex flex-column align-items-center p-2 py-3 shadow`} >
                                            {opc.icon}
                                            <h5 className=" fw-bold m-0 pt-3 " style={{ fontSize: "20px", color: "#133040" }}>
                                                {opc.title}
                                            </h5>
                                            <CardContent className="pt-2">
                                                <p className="text-gray-600 text-center " style={{ fontSize: "16px", width: "180px", color: "#4B5563" }}>
                                                    {opc.description}
                                                </p>

                                                <Button size="sm" className="mt-3 w-100  " style={{ backgroundColor: "#127AE2", border: "2px solid #127ae2" }} onClick={() => nav(opc.path)}>
                                                    Ir a {opc.title}
                                                </Button>
                                            </CardContent>
                                        </Card>
                                    </section>
                                );
                            }
                        } else {
                            if ((opc.roles &&
                                opc.roles.some((role) =>
                                    actions.user().roles?.some((userRole) => userRole.name == role)
                                )
                            ) || (
                                    opc.permisos && opc.permisos.some((permiso) => actions.user().permissions?.some((userPermiso) => userPermiso.name == permiso))
                                )) {
                                return (
                                    <section key={opc.title} className={`m-0  ${width < 640 ? "row p-3 " : width < 992 ? "row p-0" : "row p-3"} `} >
                                        <Card key={opc.title} className={` rounded d-flex flex-column align-items-center p-2 py-3 shadow`} >
                                            {opc.icon}
                                            <h5 className=" fw-bold m-0 pt-3 " style={{ fontSize: "20px", color: "#133040" }}>
                                                {opc.title}
                                            </h5>
                                            <CardContent className="pt-2">
                                                <p className="text-gray-600 text-center " style={{ fontSize: "16px", width: "180px", color: "#4B5563" }}>
                                                    {opc.description}
                                                </p>

                                                <Button size="sm" className="mt-3 w-100  " style={{ backgroundColor: "#127AE2", border: "2px solid #127ae2" }} onClick={() => nav(opc.path)}>
                                                    Ir a {opc.title}
                                                </Button>
                                            </CardContent>
                                        </Card>
                                    </section>
                                );
                            }
                        }
                    })}
                </div>
            </ContainerScreenGeneral>
        </section>
    )
}

export default MenuFM;